<template>
  <v-row>
    <v-col :cols="12" md="10" offset-md="1" lg="8" offset-lg="2" xl="6" offset-xl="3">
      <v-alert v-if="contractSigned" type="info" border="left" outlined colored-border class="ma-4">You have already confirmed your contract, so you do not need to do anything here. Your contract is still available to review below.</v-alert>
      <v-card class="ma-4">
        <v-card-title>Music Grant Contract</v-card-title>
        <v-card-text>
          <p>As we look ahead to another year of music making, it is our great pleasure to offer you the enclosed {{ awardTitle }} award. We celebrate the musical gifts that God has given to you and we rejoice in all that He is doing in our midst. We look forward to the opportunity to serve you in developing those gifts, and we eagerly anticipate how our musical collaborations will bear fruit in the life and work of our program and community.</p>
          <p>Please accept this music portion of your financial aid package online. Should you have any questions or concerns about the terms of the award or grant, let me know and I will work with you to clarify any points of confusion or to find common ground for compromise.</p>
          <p>Further information regarding hearings, initial rehearsals, and lesson schedules will be sent over in August. We pray for God’s blessings in your school year.</p>
          <p>Sincerely,</p>
          <!-- Brandon Kreuze Signature Image goes here -->
          <div>Brandon R. Kreuze, D. M.</div>
          <div>Chair, Department of Music</div>
        </v-card-text>
      </v-card>
      <v-card class="ma-4">
        <v-card-title>Music Scholarship {{ schoolYear }}</v-card-title>
        <v-card-text>
          <p>In recognition of the musical gifts demonstrated through audition and/or previous participation in our program, the Music Department of Covenant College is pleased to offer a{{ type === 'Ensemble' ? 'n' : '' }} <span style="font-weight:bold">{{ awardTitle2 }}</span> of ${{ amount.toLocaleString() }} for the <span style="font-weight:bold">{{ schoolYear }}</span> academic year.</p>
          <p>To encourage continued development of your musical abilities, the faculty and staff of the music department will:</p>
          <ul>
            <li>determine an appropriate role for you within the music program—including membership in a departmental ensemble—that best fits your musical gifts and allows you to contribute to our department and the college musical culture;</li>
            <li>provide engaging musical experiences within classes and ensembles that assist in cultivating your abilities;</li>
            <li>arrange for private lessons with one of our applied music instructors;</li>
            <li>consult with your private instructor and ensemble director throughout the academic year to monitor progress and ensure that the department is serving you well;</li>
            <li>release the funds indicated above (half for the fall semester and half for the spring) upon receiving confirmation from the Financial Aid Office that you indicated acceptance of this award electronically.</li>
          </ul>
          <p class="mt-3">To actively develop and steward the musical gifts you have been given and contribute to our music program and culture, it is understood that the <span style="font-weight:bold;font-style:italic">recipient will</span>:</p>
          <ul>
            <li>cheerfully and faithfully participate in the music program by fulfilling the responsibilities and academic obligations of an ensemble member and applied student;</li>
            <li>register for and attend private lessons in the area of applied study pertaining to the determined role;</li>
            <li>maintain a 3.0 GPA for private lessons and ensembles;</li>
            <li v-if="type === 'Major'">remain a music major as long as you accept these funds</li>
            <li v-else-if="type === 'Minor'">remain a music minor as long as you accept these funds</li>
            <li>electronically accept your music award in <a href="https://knox01.covenant.edu:8443/StudentSelfService/ssb/financialAid" target="_blank">Banner Financial Aid</a>.</li>
          </ul>
          <p class="mt-3">Music awards may be forfeited or reduced for academic or disciplinary actions which violate the Covenant College contract. Awards are not given during any semester of study abroad. Should modifications to the conditions of this award be necessitated by schedule conflicts or changes of academic direction after it is signed, you may consult with the music department chair for assistance in gaining departmental approval.</p>
          <p>I agree to the terms stated above in acceptance of this music award and confirm that I intend to participate in an ensemble as determined by the department during every semester of the {{ schoolYear }} academic year.</p>
        </v-card-text>
        <v-card-actions v-if="!contractSigned">
          <v-btn color="primary" @click="confirmContract">Agree to Terms and Confirm Contract</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { ref, computed, onMounted } from '@vue/composition-api'
export default {
  setup (props, { root }) {
    const service = root.$feathers.service('student/music/grant')
    const user = computed(() => root.$store.state.user.spoof || root.$store.state.user)

    const aidy = computed(() => {
      const dt = new Date()
      const val = (dt.getFullYear() % 100) * 101 + 1
      if (dt.getMonth() < 5) {
        return val - 101 + ''
      } else {
        return val + ''
      }
    })
    const schoolYear = computed(() => '20' + aidy.value.substring(0, 2) + '-20' + aidy.value.substring(2))

    const contractId = ref('')
    const type = ref('')
    const status = ref('')
    const amount = ref(1000)
    const contractSigned = ref(false)

    const awardTitle = computed(() => {
      if (type.value === 'Major') return 'music major scholarship'
      else if (type.value === 'Minor') return 'music minor scholarship'
      else return 'ensemble grant'
    })
    const awardTitle2 = computed(() => {
      if (type.value === 'Major') return 'music major award'
      else if (type.value === 'Minor') return 'music minor award'
      else return 'ensemble grant'
    })

    onMounted(async () => {
      const { data } = await service.find({ query: { pidm: user.value.pidm, aidy: aidy.value } })
      if (data.length > 0) {
        contractId.value = data[0]._id
        type.value = data[0].type
        status.value = data[0].status
        amount.value = data[0].amount
        contractSigned.value = ('contractSigned' in data[0])
      }
    })

    async function confirmContract () {
      try {
        await service.patch(contractId.value, { contractSigned: new Date() })
        contractSigned.value = true
      } catch (e) {
        console.log(e)
        root.$store.dispatch('main/snackbar', { color: 'error', text: `Error confirming contract: ${e}. Please contact Technology Services for assistance.` })
      }
    }

    return {
      user,
      aidy,
      schoolYear,
      contractId,
      type,
      status,
      amount,
      contractSigned,
      awardTitle,
      awardTitle2,
      confirmContract
    }
  }
}
</script>
